// @ts-nocheck

import { actions } from '../actions/login';
import runtimeActions from '../actions/runtime';
import userActions from '../actions/user';
import Client, { Target } from '../client';
import config from '../config/app.config';
import { getAuthManager } from '../managers/authManager';
import { NetworkActionTypes } from '../types/actions/network';
import { UserActionTypes } from '../types/actions/user';
import { getJwtFromCookies } from '../utils/user';

let interval = null;
let i = 0;

export default ({ dispatch, getState }) => {
  const onTimerTick = () => {
    // eslint-disable-next-line sonarjs/no-duplicate-string
    console.debug(`%c app | keepalive tick `, 'background: #616161; color: #fff;');
    runtimeActions.doRefreshKeepAlive(i++ === 0)(dispatch, getState);
  };
  return (next) => (action) => {
    const {
      user: { connected },
      runtime: { licence },
    } = getState();
    if (action.type === '@@APP_INIT') {
      if (connected) {
        if (interval) {
          console.debug(`%c app | reset keepalive `, 'background: #616161; color: #fff;');
          clearInterval(interval);
          interval = null;
        }
        console.debug(`%c app | start keepalive `, 'background: #616161; color: #fff;');
        interval = setInterval(onTimerTick, config.keepalive.waitInterval);
        i = 0;
      }

      const jwt = getJwtFromCookies();

      if (jwt) {
        getAuthManager().initWithJWT(jwt);
      }
    } else if (action.type === UserActionTypes.SET_CONNECTED) {
      if (interval) {
        console.debug(`%c app | reset keepalive `, 'background: #616161; color: #fff;');
        clearInterval(interval);
        interval = null;
      }
      console.debug(`%c app | start keepalive `, 'background: #616161; color: #fff;');
      interval = setInterval(onTimerTick, config.keepalive.waitInterval);
      i = 0;
    } else if (action.type === UserActionTypes.SET_DISCONNECTED) {
      console.debug(`%c app | stop keepalive `, 'background: #616161; color: #fff;');
      clearInterval(interval);
    } else if (action.type === NetworkActionTypes.CONNECTED) {
      // Dans le cas d'une connection, on reset le compteur pour renvoyer un keepalive init=1 afin de recevoir les favoris #784
      i = 0;
    } else if (action.type === NetworkActionTypes.RECV) {
      const { ccOk, ccKo } = action.payload;
      if (ccOk) {
        onTimerTick();
      } else if (ccKo) {
        if (connected) {
          // Ca génère beaucoup de messages sur Sentry, mis en commentaire car non exploité pour le moment
          // Sentry.captureMessage('User sign-out from ccKo received');

          if (Target.__MOBILE__ && Client.embed) {
            // On essaie de s'authentifier silencieusement
            actions
              .tryLoginEmbedded(
                licence,
                'cc-ko',
              )(dispatch)
              .then((success) => {
                if (!success) {
                  dispatch(userActions.setDisconnected());
                }
              })
              .catch(() => {
                dispatch(userActions.setDisconnected());
              });
          } else {
            dispatch(userActions.setDisconnected());
          }
        }
      }
    }
    return next(action);
  };
};
